<template>
<base-modal v-model="isVisible" :title="$t('professionalPrevalidated.title')" @shown="resetForm">
  <div class="text-center">
    <p v-html="$t('professionalPrevalidated.description')"></p>
    <base-input :placeholder="$t('professionalPrevalidated.email')" v-model="email"></base-input>
    <base-checkbox v-model="termsAccepted">
      <span v-html="$t('signupOH.accept-terms')"></span>
    </base-checkbox>
    <VueRecaptcha class="custom-recaptcha" :sitekey="siteKey" :load-recaptcha-script="true" @verify="validCaptcha = true" @error="validCaptcha = false" @expired="validCaptcha = false"></VueRecaptcha>
    <base-button class="mt-4" @click="sendForm">{{$t('send')}}</base-button>
  </div>
</base-modal>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { recaptcha } from '@/constants/recaptcha'
import BaseModal from '@/components/base/BaseModal.vue'
import professionalRepository from '@/repositories/ProfessionalRepository'

export default {
  components: {
    BaseModal,
    VueRecaptcha
  },
  props: {
    profId: String,
    value: Boolean
  },
  data () {
    return {
      email: null,
      termsAccepted: false,
      validCaptcha: false,
      siteKey: recaptcha
    }
  },
  methods: {
    sendForm () {
      if (this.$validators.validate(this.email, ['email']) === false) {
        this.$store.dispatch('showInfoAlert', this.$t('professionalPrevalidated.error.email'))
      } else if (!this.termsAccepted) {
        this.$store.dispatch('showInfoAlert', this.$t('professionalPrevalidated.error.terms'))
      } else if (!this.validCaptcha) {
        this.$store.dispatch('showInfoAlert', this.$t('professionalPrevalidated.error.captcha'))
      } else {
        professionalRepository.notifyPrevalidatedProfessional({ profId: this.profId, patientEmail: this.email }).then(response => {
          if (response.data) {
            this.$store.dispatch('showSuccessAlert', this.$t('professionalPrevalidated.success'))
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
          }
          this.resetForm()
          this.isVisible = false
        })
      }
    },
    resetForm () {
      this.email = null
      this.termsAccepted = false
      this.validCaptcha = false
    }
  },
  computed: {
		isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
		}
	}
}
</script>

<style lang="scss" scoped>
/deep/ .custom-recaptcha > div {
  width: auto !important;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/ProfessionalPrevalidatedModal.vue